export const safeGetProjectName = (): string | undefined =>
  window && (window as any)?.hubspot?.bender?.currentProject;
